/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-inscrire-dossier': {
    width: 16,
    height: 16,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M13.12 0H4.88a.39.39 0 00-.27.11l-4.5 4.5a.39.39 0 00-.11.27v11.24a.38.38 0 00.38.38h8.76a.38.38 0 00.34-.5A4.73 4.73 0 019 13.88a4.89 4.89 0 014.18-4.82.38.38 0 00.32-.37V.38a.38.38 0 00-.38-.38zm-9 4.5H1.28L4.5 1.28v2.84a.38.38 0 01-.38.38zm9.76 5.25A4.13 4.13 0 1018 13.88a4.13 4.13 0 00-4.12-4.13zm1.5 4.5h-1.13v1.13a.38.38 0 01-.75 0v-1.13h-1.12a.38.38 0 110-.75h1.12v-1.12a.38.38 0 11.75 0v1.12h1.13a.38.38 0 010 .75z"/>'
  }
})
